module.exports = __webpack_public_path__ + "assets/72f3e2476a1be32cf7247769ab5cddc8.png";